import React, { useContext, useEffect, useState } from "react";
import DirectionsContext from "../../../Context/Directions/DirectionsContext";
import { Card } from "../ProfileDirections/Card/Card";
import { Grid } from "@mui/material";

const ProfileDirections = () => {
  const { GetDirections, directions } = useContext(DirectionsContext);
  const [active, setActive] = useState(-1);

  useEffect(() => {
    GetDirections();
  }, []);

  const handleCollapse = (index) => {
    setActive((prev) => (prev === index ? -1 : index));
  };

  return (
    <Grid container spacing={2} sx={{ p: 4 }}>
      {directions.map((direction, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card
            index={index}
            onCollapse={handleCollapse}
            order={direction}
            active={active}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProfileDirections;
